import { FC } from 'react'

import FollowUpProvider from '@provider/Otb/FollowUpProvider'
import PlanProvider from '@provider/Otb/PlanProvider'

const OtbProviders: FC = ({ children }) => {
  return (
    <FollowUpProvider>
      <PlanProvider>{children}</PlanProvider>
    </FollowUpProvider>
  )
}

export default OtbProviders
